export default __webpack_public_path__ + "static/media/foto6.b18eef33.jpg";